export default __webpack_public_path__ + "static/media/logo_adich.f26d1780.png";